import { useCallback, useEffect, useState } from 'react';
import { SLIDES } from '../../../config/slider';
import styles from './HeroSlider.module.css';

function SlideMedia({ item, priority = false }) {
  const image = (
    <picture className={styles.picture}>
      {item.imageMobile && (
        <source media="(max-width: 767px)" srcSet={item.imageMobile} type="image/webp" />
      )}
      <img
        src={item.image}
        alt={item.alt}
        className={styles.image}
        loading={priority ? 'eager' : 'lazy'}
      />
    </picture>
  );

  if (!item.href) {
    return image;
  }

  const isExternal = /^https?:\/\//i.test(item.href);

  return (
    <a
      href={item.href}
      className={styles.link}
      {...(isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
    >
      {image}
    </a>
  );
}

export function HeroSlider() {
  const [active, setActive] = useState(0);
  const total = SLIDES.length;

  const next = useCallback(() => {
    setActive((i) => (i + 1) % total);
  }, [total]);

  const prev = useCallback(() => {
    setActive((i) => (i - 1 + total) % total);
  }, [total]);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <section className={styles.slider} aria-label="Промо-слайдер">
      <div className={styles.track}>
        {SLIDES.map((item, index) => (
          <div
            key={item.id}
            className={`${styles.slide} ${index === active ? styles.slideActive : ''}`}
            aria-hidden={index !== active}
          >
            <SlideMedia item={item} priority={index === 0} />
          </div>
        ))}
      </div>

      <button type="button" className={`${styles.arrow} ${styles.arrowPrev}`} onClick={prev} aria-label="Предыдущий слайд">
        ‹
      </button>
      <button type="button" className={`${styles.arrow} ${styles.arrowNext}`} onClick={next} aria-label="Следующий слайд">
        ›
      </button>

      <div className={styles.dots}>
        {SLIDES.map((item, index) => (
          <button
            key={item.id}
            type="button"
            className={`${styles.dot} ${index === active ? styles.dotActive : ''}`}
            onClick={() => setActive(index)}
            aria-label={`Слайд ${index + 1}: ${item.alt}`}
          />
        ))}
      </div>
    </section>
  );
}
